let isBundleProcessing = false;
let baseUrl = "https://bundle-app-production-29e9.up.railway.app";
let bundlePopup = document.querySelector(".bundle_popup");
document.addEventListener("DOMContentLoaded", async () => {
    checkBundles();
});

async function checkDiscount(discountId){
    try {
        const discResponse = await fetch(`${baseUrl}/get-discount-info/${discountId}`);
        
        if (!discResponse.ok) {
            throw new Error(`cant fetch the discount: ${discResponse.status}`);
        }
        
        const discData = await discResponse.json();
        return discData;
    } catch (error) {
        console.error('Error getting discount information:', error);
        return null;
    }
}

async function checkBundles() {
    if (isBundleProcessing) return;
    let reqCartItemsId = await fetchCart();
    const freeVariantMap = {};
    if(shopBundles != null){
        shopBundles.sort((a, b) => a.priority - b.priority);
        for(let bundleData of shopBundles){
            freeVariantMap[bundleData.free_variant_id] ??= [];
            freeVariantMap[bundleData.free_variant_id].push(bundleData);
        }
    }


    for (let freeVariantId in freeVariantMap) {
        freeVariantMap[freeVariantId].sort((a, b) => a.priority - b.priority);
    }

    let discountIsApplied = false;

    for(let freeVariantId in freeVariantMap){
        if(discountIsApplied) return
        let winnerBundle = freeVariantMap[freeVariantId][0];
        if(winnerBundle.type_of_bundle == "buy x get y"){
            let bundleTracking = true;
            let count = winnerBundle.required_variants.length;
            for(let i=0;i<count;i++){
                if(!reqCartItemsId.includes(winnerBundle.required_variants[i])){
                    bundleTracking = false;
                }
            }
            if(bundleTracking){
                let bundleState = true;
                let discId = winnerBundle.discountId
                let reqId = discId.split("/")[discId.split("/").length - 1];
                const discData = await checkDiscount(reqId);
                let disct = discData.discount.discount;
                winnerBundle.bundle_status = disct.status;
                if(winnerBundle.bundle_status == "EXPIRED" || winnerBundle.bundle_status == "SCHEDULED"){
                    bundleState = false;
                }
                if(winnerBundle.bundle_status == "SCHEDULED"){
                    if(disct.status != winnerBundle.bundle_status) winnerBundle.bundle_status = disct.status;
                    if(disct.startsAt != winnerBundle.bundle_startsAt) winnerBundle.bundle_startsAt = disct.startsAt;
                    if(disct.endsAt != winnerBundle.bundle_endsAt) winnerBundle.bundle_endsAt = discData.discount.endsAt;
                    let today = new Date().toISOString();
                    let startDate = winnerBundle.bundle_startsAt;
                    let endDate = winnerBundle.bundle_endsAt;
                    if(today > startDate && endDate == null){
                        bundleState = true
                    }
                    if(today > startDate && endDate > today){
                        bundleState = true
                    }
                }

                if(bundleState){
                    bundlePopup.classList.remove("hide");
                    if(!reqCartItemsId.includes(winnerBundle.free_variant_id)){
                        isBundleProcessing = true;
                        let currentQty = winnerBundle.free_quantity;
                        try {
                            const cartAddResponse = await fetch('/cart/add.js', {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json'
                                },
                                body: JSON.stringify({
                                    id: winnerBundle.free_variant_id,
                                    quantity: currentQty
                                })
                            });

                            if (!cartAddResponse.ok) {
                                throw new Error(`Cart add failed: ${cartAddResponse.status}`);
                            }

                            const cartAddData = await cartAddResponse.json();

                            if(cartAddData){
                                if(window.location.pathname === '/cart'){
                                    try{
                                        const cartPagResponse = await fetch('/cart');
                                        if (!cartPagResponse.ok) {
                                            throw new Error(`Cart page fetch failed: ${cartPagResponse.status}`);
                                        }
                                        const cartPageHtml = await cartPagResponse.text();
                                        const parser = new DOMParser();
                                        const cartPageDocument = parser.parseFromString(cartPageHtml, 'text/html');
                                        let cartPage = cartPageDocument.querySelector('html').innerHTML;
                                        const newCartWrapper = cartPageDocument.querySelector('#shopify-section-cart-template');
                                        document.getElementById("shopify-section-cart-template").innerHTML = newCartWrapper.innerHTML;
                                    } catch(err){
                                        console.error('Error getting cart page data:', err);
                                        isBundleProcessing = false;
                                    }
                                }
                                let cartCount = document.getElementById('CartCount').querySelector('span[data-cart-count]');
                                const cart = await fetch('/cart.js').then(r => r.json());
                                let countNum = cart.item_count;
                                let popCount = document.querySelector(".cart-popup-wrapper [data-cart-popup-cart-quantity]");
                                popCount.innerText = countNum;
                                cartCount.innerText = countNum;
                                discountIsApplied = true;
                                isBundleProcessing = false;
                                bundlePopup.classList.remove("hide");
                            }
                        } catch (error) {
                            console.error('Error adding product to cart:', error);
                            isBundleProcessing = false;
                        }
                    }
                }
            }
        }

        if(winnerBundle.type_of_bundle == "buy x get y combination"){
            let count = winnerBundle.count_of_products;
            let curCount = 0;
            for(let i=0;i<winnerBundle.required_variants.length;i++){
                if(reqCartItemsId.includes(winnerBundle.required_variants[i])){
                    ++curCount;
                }
            }
            if(curCount >= count){
                if(!reqCartItemsId.includes(winnerBundle.free_variant_id)){
                    let bundleState = true;
                    let discId = winnerBundle.discountId
                    let reqId = discId.split("/")[discId.split("/").length - 1];
                    const discData = await checkDiscount(reqId);
                    let disct = discData.discount.discount;
                    winnerBundle.bundle_status = disct.status;
                    if(winnerBundle.bundle_status == "EXPIRED" || winnerBundle.bundle_status == "SCHEDULED"){
                        bundleState = false;
                    }
                    if(winnerBundle.bundle_status == "SCHEDULED"){
                        if(disct.status != winnerBundle.bundle_status) winnerBundle.bundle_status = disct.status;
                        if(disct.startsAt != winnerBundle.bundle_startsAt) winnerBundle.bundle_startsAt = disct.startsAt;
                        if(disct.endsAt != winnerBundle.bundle_endsAt) winnerBundle.bundle_endsAt = discData.discount.endsAt;
                        let today = new Date().toISOString();
                        let startDate = winnerBundle.bundle_startsAt;
                        let endDate = winnerBundle.bundle_endsAt;
                        if(today > startDate && endDate == null){
                            bundleState = true
                        }
                        if(today > startDate && endDate > today){
                            bundleState = true
                        }
                    }

                    if(bundleState){
                        bundlePopup.classList.remove("hide");
                        isBundleProcessing = true;
                        let currentQty = winnerBundle.free_quantity;
                        try {
                            const cartAddResponse = await fetch('/cart/add.js', {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json'
                                },
                                body: JSON.stringify({
                                    id: winnerBundle.free_variant_id,
                                    quantity: currentQty
                                })
                            });

                            if (!cartAddResponse.ok) {
                                throw new Error(`Cart add failed: ${cartAddResponse.status}`);
                            }

                            const cartAddData = await cartAddResponse.json();

                            if(cartAddData){
                                if(window.location.pathname === '/cart'){
                                    try{
                                        const cartPagResponse = await fetch('/cart');
                                        if (!cartPagResponse.ok) {
                                            throw new Error(`Cart page fetch failed: ${cartPagResponse.status}`);
                                        }
                                        const cartPageHtml = await cartPagResponse.text();
                                        const parser = new DOMParser();
                                        const cartPageDocument = parser.parseFromString(cartPageHtml, 'text/html');
                                        let cartPage = cartPageDocument.querySelector('html').innerHTML;
                                        const newCartWrapper = cartPageDocument.querySelector('#shopify-section-cart-template');
                                    } catch(err){
                                        console.error('Error getting cart page data:', err);
                                        isBundleProcessing = false;
                                    }
                                }
                                let cartCount = document.getElementById('CartCount').querySelector('span[data-cart-count]');
                                const cart = await fetch('/cart.js').then(r => r.json());
                                let countNum = cart.item_count;
                                let popCount = document.querySelector(".cart-popup-wrapper [data-cart-popup-cart-quantity]");
                                popCount.innerText = countNum;
                                cartCount.innerText = countNum;
                                discountIsApplied = true;
                                isBundleProcessing = false;
                                bundlePopup.classList.remove("hide");
                            }
                        } catch (error) {
                            console.error('Error adding product to cart:', error);
                            isBundleProcessing = false;
                        }
                    }
                }
            }
        }
    }
}

async function fetchCart() {
    let cartResponse = await fetch('/cart.js');
    if (!cartResponse.ok) {
        throw new Error('Cart request failed');
    }
    let cartData = await cartResponse.json();
    let reqCartItemsId = [];
    let cartItems = cartData.items;
    for(let cartElement of cartItems){
        reqCartItemsId.push(cartElement.id);
    }
    return reqCartItemsId;
}